import { mapGetters } from 'vuex';
import IconPlay from '@/components/icons/IconPlay.vue';

export default {
  name: 'HomeVideo',
  components: { IconPlay },
  props: {
    video: {
      type: String,
      default: ''
    },
    news: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      videoStatus: false
    };
  },
  created() {},
  mounted() {
    if (this.video) {
      this.$refs.refVideo.src = this.video;
    }
  },
  computed: {
    ...mapGetters({
      appSize: 'app/size'
    })
  },
  methods: {
    onPlayVideo() {
      this.videoStatus = !this.videoStatus;
      this.videoStatus ? this.$refs.refVideo.play() : this.$refs.refVideo.pause();
    }
  }
};
